import React, { useCallback, useEffect, useRef, useState } from 'react'
import Button from '../../components/UI/Button'
import { CloseOutlined, CheckOutlined, DeleteOutlined } from '@ant-design/icons'
import { numberToCurrency } from '../../utils/objectUtils'
import { iItemGameList, iListGames } from './RawHtml'
import {Tooltip} from "antd";

type onCloseDeck = (id: string, itemGame: iItemGameList, gameName: string) => void

interface IItemGameProps {
  itemGame: iItemGameList,
  game: iListGames,
  checkBody: (id: string, itemGame?: iItemGameList) => void,
  getFlare: (id: number, form: string) => void,
  canEdit: boolean,
  onCloseDeck:onCloseDeck
  variants: iItemGameList[]
  gameGroup?: string | null;
  gameAutoClose: boolean;
  gameAutoCreate: boolean;
  gameGroups: any
}

interface IItemGameCellnoVariant {
  itemGame: iItemGameList,
  getFlare: (id: number, form: string) => void,
  canEdit: boolean,
  onCloseDeck: onCloseDeck
  game: iListGames;
}

interface IItemGameCellWithVariant {
  variants: iItemGameList[],
  itemGame: iItemGameList,
  getFlare: (id: number, form: string) => void,
  canEdit: boolean,
  onCloseDeck: onCloseDeck
  game: iListGames;
}

function ItemGame(props: IItemGameProps) {
  const {itemGame, game, checkBody, getFlare, canEdit, onCloseDeck, variants, gameGroup, gameAutoCreate, gameAutoClose , gameGroups} = props
  if (gameGroup && variants.length === 0) return <></>
  const ref: React.RefObject<HTMLInputElement> = useRef(null)

  const [avaliable, setAvaliable] = useState(ref.current?.checked)
    //console.log(`gameGroups(20000) ${JSON.stringify(gameGroups.get("20000"))}`)
    //console.log(`Game ${itemGame.form} GameGroup: ${itemGame.gameGroup} GameGroupNull: ${itemGame.gameGroup==null} gameGroups: ${JSON.stringify(gameGroups.get(itemGame.gameGroup))}`)
  const setRefreshComponent = (e:any) => {
    setAvaliable(e.target.checked)
    checkBody(game.id, itemGame)
  }

  useEffect(() => {
    setAvaliable(ref.current?.checked)
  }, [])
  return (
      <>
          {(itemGame.gameGroup == null || gameGroups.get(itemGame.gameGroup) == null || gameGroups.get(itemGame.gameGroup).mismatch === false ) && (
          <tr key={itemGame.id} style={{color: itemGame.gameAvailable ? "black" : "red"}}>
          <td>
              <Tooltip title={!itemGame.gameAvailable ? "Game not available to play "
                      .concat(itemGame.gameAvailableStartSetting ? "before " + itemGame.gameAvailableStart : "")
                      .concat(itemGame.gameAvailableEndSetting && itemGame.gameAvailableStartSetting ? " or " : "")
                      .concat(itemGame.gameAvailableEndSetting ? "after " + itemGame.gameAvailableEnd : "")
                  : ""}
                       placement="top" arrow>
                  {numberToCurrency(itemGame.wager) || '--'}
              </Tooltip>
          </td>
          <td>
              <input
                  disabled={!canEdit}
                  id={`avaliable_${itemGame.id}`}
                  data-avaliable="true"
                  data-avaliable-id={`${game.id}`}
                  onClick={(e) => setRefreshComponent(e)}
                  data-wager={itemGame.wager}
                  type="checkbox"
                  ref={ref}
              />
          </td>
          <td>
              <Tooltip title={!gameAutoCreate ? "Disabled by Manufacturer" : ""} placement="top" arrow>
                  <input
                      id={`auto-create_${itemGame.id}`}
                      data-create="true"
                      data-create-id={`${game.id}`}
                      onClick={() => checkBody(game.id)}
                      type="checkbox"
                      disabled={!canEdit || (!ref.current?.checked || !gameAutoCreate)}

                  />
              </Tooltip>
          </td>
          <td>
              <Tooltip title={!gameAutoClose ? "Disabled by Manufacturer" : ""} placement="top" arrow>
                  <input
                      id={`auto-close_${itemGame.id}`}
                      data-close="true"
                      data-close-id={`${game.id}`}
                      type="checkbox"
                      onClick={() => checkBody(game.id)}
                      disabled={!canEdit || (!ref.current?.checked || !gameAutoClose)}
                  />
              </Tooltip>
          </td>
          {!gameGroup && variants.length === 0 && (
              <ItemGameWithNoVariant
                  itemGame={itemGame}
                  getFlare={getFlare}
                  canEdit={canEdit}
                  onCloseDeck={onCloseDeck}
                  game={game}
              />
          )}

          {gameGroup && variants.length > 0  && (
              <ItemGameWithVariant
                  itemGame={itemGame}
                  variants={variants}
                  getFlare={getFlare}
                  canEdit={canEdit}
                  onCloseDeck={onCloseDeck}
                  game={game}
              />
          )}

      </tr>
              )}
      </>
  )
}

export default ItemGame

function ItemGameWithNoVariant(props: IItemGameCellnoVariant) {
    //console.log("in with No variant: " + props.itemGame.form)
  const { itemGame, getFlare, canEdit, onCloseDeck, game} = props
  return (
    <>    
      <td>{itemGame.form || '--'}</td>
      <td>{itemGame.tickets || '--'}</td>
      <td>
        <Button
          style={{width: '75%', margin: '0 auto', textAlign: 'center'}}
          type='primary'
          onClick={() => getFlare(itemGame.id, itemGame.form)}
        >
          <p>View Flare</p>
        </Button>
      </td>
      <td>{itemGame.variant || '--'}</td>
      <td>{itemGame.serial || '--'}</td>
      <td>{itemGame.remaining || '--'}</td>
      <td>
        <Button
          disabled={itemGame.serial==='' || itemGame.serial===' ' || itemGame.serial==='(generation)'|| !canEdit}
          onClick={() => onCloseDeck(itemGame.form, itemGame, game.title)}
          type='primary'
          style={{ backgroundColor: '#d41d24', width: 'fit-content', margin: '0 auto' }}

        >
          <CloseOutlined style={{ fontSize: '12px', color: '#FFF' }} />
        </Button>
      </td>
    </>
  )
}
function ItemGameWithVariant(props: IItemGameCellWithVariant) {
    //console.log("in with variant: " + props.itemGame.form)
  const {itemGame, variants, getFlare, canEdit, onCloseDeck, game} = props

  const getItemCell = (key: string) => {
    if(key === 'getFlare')  {
      return variants.map((variant) => 
        <div className="flare__row flare__row--button">
          <Button
              style={{width: '75%', margin: '0 auto', textAlign: 'center'}}
              type='primary'
            onClick={() => getFlare(variant.id, variant.form)}
          >
            <p>View Flare</p>
          </Button>
          <br/>
        </div>
      )
    }
    if(key === 'onCloseDeck')  {
      return variants.map((variant) => 
        <div className="flare__row flare__row--button">
          <Button
            disabled={variant.serial==='' || variant.serial===' ' || variant.serial==='(generation)'|| !canEdit}
            onClick={() => onCloseDeck(variant.form, itemGame, game.title)}
            type='primary'
            style={{ backgroundColor: '#d41d24', width: 'fit-content', margin: '0 auto' }}
          >
            <CloseOutlined style={{ fontSize: '12px', color: '#FFF' }} />
          </Button>
        </div>
      )
    }
    return variants.map((variant) => 
      <div className="flare__row">
        {variant[key as keyof typeof variant] || '--'}
      </div>
    )
  }

  return (
    <>    
      <td>
        <div className="flare__row">{itemGame.form || '--'}</div> 
        {getItemCell('form')}
      </td>
      <td>
        <div className="flare__row">{itemGame.tickets || '--'}</div>   
        {getItemCell('tickets')}
      </td>
      <td >
        <div className="flare__row flare__row--button">
          <Button
            style={{width: '75%', margin: '0 auto', textAlign: 'center'}}
            type='primary'
            onClick={() => getFlare(itemGame.id, itemGame.form)}
          >
            <p>View Flare</p>
          </Button>
        </div>
        {getItemCell('getFlare')}
      </td>
      <td>
        <div className="flare__row">{itemGame.variant || '--'}</div> 
        {getItemCell('variant')}
      </td>
      <td>
        <div className="flare__row">{itemGame.serial || '--'}</div> 
        {getItemCell('serial')}
      </td>
      <td>
        <div className="flare__row">{itemGame.remaining || '--'}</div> 
        {getItemCell('remaining')}
      </td>
      <td>
        <div className="flare__row flare__row--button">
          <Button
            disabled={!itemGame.avaliable || !canEdit}
            onClick={() => onCloseDeck(itemGame.form, itemGame, game.title)}
            type='primary'
            style={{ backgroundColor: '#d41d24', width: 'fit-content', margin: '0 auto' }}
          >
            <CloseOutlined style={{ fontSize: '12px', color: '#FFF' }} />
          </Button>
        </div> 
        {getItemCell('onCloseDeck')}
      </td>
    </>
  )
}
